import {createSelector} from 'reselect';

import {
  makeSectionLinePlotPanelsSelector,
  makeSectionSettingsSelector,
} from '../../../state/views/panelBankSectionConfig/selectors';
import {Ref as SectionRef} from '../../../state/views/panelBankSectionConfig/types';
import {makeAllLinePlotSectionsAndPanelsSelector} from '../panelBankConfig/selectors';
import {Ref as PanelBankConfigRef} from '../panelBankConfig/types';
import {makePartSelector} from '../selectors';
import {
  getPanelsThatOverrideWorkspaceSettings,
  getSectionsThatOverrideWorkspaceSettings,
} from './settingOverrideUtils';
import {Ref as WorkspaceSettingsRef} from './types';

export const makeWorkspaceSettingOverridesSelector = (
  workspaceSettingsRef: WorkspaceSettingsRef,
  panelBankConfigRef: PanelBankConfigRef
) => {
  return createSelector(
    makePartSelector(workspaceSettingsRef),
    makeAllLinePlotSectionsAndPanelsSelector(panelBankConfigRef),
    (workspaceSettings, {sections, panels}) => {
      const overrides = {
        panelOverrides: getPanelsThatOverrideWorkspaceSettings(
          panels,
          workspaceSettings
        ),
        sectionOverrides: getSectionsThatOverrideWorkspaceSettings(
          sections,
          workspaceSettings
        ),
      };

      return overrides;
    }
  );
};

export const makeSectionSettingOverridesSelector = (sectionRef: SectionRef) => {
  return createSelector(
    makeSectionSettingsSelector(sectionRef),
    makeSectionLinePlotPanelsSelector(sectionRef),
    (sectionSettings, panels) => {
      const overrides = {
        panelOverrides: getPanelsThatOverrideWorkspaceSettings(
          panels,
          sectionSettings
        ),
      };
      return overrides;
    }
  );
};
